<template>
  <iframe
    :src="rmasrc"
    ref="theframe"
    style="border: 0; position: absolute; height: 100%; width: 100%; left: 0; top: 0;"
  ></iframe>
</template>

<script>

export default {
  name: "csvorder",
  data: () => ({
  }),
computed: {
    rmasrc() {
      return "https://qgistix.com/qg_shipment_up.html?nocache=" + (new Date()).getTime() 
    }
  },
  methods: {
  }
}
</script>
